import React from "react";
import "../broadcast.css";
import "./createBroadcast.css";
import strings from "../../../utils/property-file/broadcast.json";
import { useNavigate } from "react-router-dom";
import BackArrow from "../../../Asset/Images/back-arrow.svg"
import constants from "../../../utils/constants";
import Select from 'react-select'
import appStyles from "../../../utils/appStyles";
import AddImage from "../../../Asset/Images/add-image-icon.svg"
import { useEffect, useState } from "react";
import bytesToMB from "../../../utils/commonFunction/bytesToMb";
import { toast } from "react-toastify";
import RemoveIcon from "../../../Asset/Images/subtract-icon.svg";
import api from "../../../services/api";
import SpinnerButtonMedium from "../../button/SpinnerButtonMedium";
import SpinnerButton from "../../button/spinnerButton";

export default function CreateBroadCast(){
    const nav = useNavigate();
    const [broadCastReachability , setBroadcastReachability] = useState(true);
    const [employeeNames , setEmployeeNames]  = useState([]);
    const [imageArray, setImageArray] = useState([])  
    const [titleOfBroadcast ,setTitleOfNotification] = useState("");
    const [typeBroadcast ,  setTypeBroadcast]  = useState(null);
    const [selectedEmployee , setSelectedEmployee] = useState([]);
    const [contentOfNotification , setContentOfNotification] = useState("");
    const [creatingBroadcast , setCreatingBroadcast] = useState(false);
    const [fetchingEmployeeName , setFetchingEmployeeName] = useState(true);
    const [fileNumber ,setFileNumber] = useState();

    // getEmployeesNames API is integrated for the fetching the name of active employee

    const getEmployeeNames =  async () =>{
        try {
            const response = await api.getEmployeeStatus("");
            if(response && response.data) {
                if(response.success) {
                const data = JSON.parse(response.data);
                setEmployeeNames(data.body);
                }
                else {
                    setEmployeeNames([]);
                }
            } 
            setFetchingEmployeeName(false);
        }
        catch (error) {
            setFetchingEmployeeName(false);
            toast.error(strings.somethingWentWrong , {toastId : strings.errorCode})
            setEmployeeNames([]);
        }
    }

    //When we get the success response from create broadcast api then we pass the broadcast id here for uploading photo on firebase

    const uploadPhoto= async (id) =>{
        try {
                const response = await api.uploadBroadcastPhoto(id ,imageArray); 
                if(response && response.data) {
                    const data= JSON.parse(response.data);
                    if(response.success){
                        toast.success(data.body , {toastId : strings.successCode});
                        setCreatingBroadcast(false);
                        nav(constants.navigationLink.broadcast);
                    } 
                    else {
                        toast.error(data.body , {toastId : strings.errorCode})
                    }
                }
        }
        catch (error) {
            setCreatingBroadcast(false);
            toast.error(strings.somethingWentWrong , {toastId : strings.errorCode})
        }
    }

    // Create broadcast api is use to create the broadcast 
    // In the body pass the following details :
    // title : "title of broadcast"
    // type : "type of broadcast"
    // content : "content of broadcast"
    // all : "true/false"
    // employeeId : "selectedEmpId"

    const createBroadCast = async () =>{
        try {
            if(contentOfNotification.length>=300) {
                toast.error(strings.contentError , {toastId : strings.errorCode});
                return;
            }
            if(titleOfBroadcast.length>=50) {
                toast.error(strings.titleError , {toastId : strings.errorCode});
                return;
            }
            if(selectedEmployee.length<=0 && !broadCastReachability) {
                toast.error(strings.selectEmployeeFirst , {toastId : strings.errorCode});
                return;
            }
            setCreatingBroadcast(true);
            let selectedEmployeeIds = [];
                if (selectedEmployee !== null) {
                selectedEmployeeIds = selectedEmployee.map((selectEmployee) => {
                    return selectEmployee.value;
                });
                }
            const body = {
                title : titleOfBroadcast? titleOfBroadcast.trim() : null,
                type : typeBroadcast? typeBroadcast.value : null ,
                content : contentOfNotification ? contentOfNotification : null,
                all  : broadCastReachability? true : false, 
                employeeId : broadCastReachability? null : selectedEmployeeIds
            }
           const response = await api.createBroadcast(body);
           if(response && response.data) {
            const data = JSON.parse(response.data);
            if(response.success) {
                await  uploadPhoto(data.idToSend);
                toast.success(data.body , {toastId : strings.successCode})
            }
            else {
                toast.error(data.body , {toastId : strings.errorCode});
                setCreatingBroadcast(false);
            }
           }
        }
        catch (error) {
            setCreatingBroadcast(false);
            toast.error(strings.somethingWentWrong , {toastId : strings.errorCode})
        }
    }

    // Here we filter the employee on the basis of status of employee
    const activeEmployees =
    employeeNames != null
      ? employeeNames
          .map((employee) => {
            if (employee.isActive) {
              return { value: employee._id, label: employee.name };
            }
            return null;
          })
          .filter(Boolean)
      : null;

    useEffect(()=>{
        getEmployeeNames();
    },[])
    
    function removeFileFirst () {
        imageArray[0]=null;
        setFileNumber(fileNumber-1);
        const firstImage = document.getElementById("first-uploaded-broadcast");
        const removeIcon= document.getElementById("first-image-remove-icon");
        const newElem = document.getElementById('first-broadcast-image');
        const temp = document.createElement('div');
        temp.className= "limit-broadcast-image"
        temp.innerText= strings.limitLabel;
        newElem.appendChild(temp)
        firstImage.className="add-img-icon-broadcast"
        firstImage.src=AddImage;
        removeIcon.className="d-none"
    }

    function removeFileSecond () {
        imageArray[1]=null;
        setFileNumber(fileNumber-1);
        const firstImage = document.getElementById("second-uploaded-broadcast");
        const removeIcon= document.getElementById("second-image-remove-icon");
        const newElem = document.getElementById('second-broadcast-image');
        const temp = document.createElement('div');
        temp.className= "limit-broadcast-image"
        temp.innerText= strings.limitLabel;
        newElem.appendChild(temp)
        firstImage.className="add-img-icon-broadcast"
        firstImage.src=AddImage;
        removeIcon.className="d-none"
        removeIcon.className="d-none"
    }

    function removeFileThird () {
        imageArray[2]=null;
        setFileNumber(fileNumber-1);
        const firstImage = document.getElementById("third-uploaded-broadcast");
        const removeIcon= document.getElementById("third-image-remove-icon");
        const newElem = document.getElementById('third-broadcast-image');
        const temp = document.createElement('div');
        temp.className= "limit-broadcast-image"
        temp.innerText= strings.limitLabel;
        newElem.appendChild(temp)
        firstImage.className="add-img-icon-broadcast"
        firstImage.src=AddImage;
        removeIcon.className="d-none"
        removeIcon.className="d-none"
    }
    
    function firstFileUpload(event) {
        const uploadedFileFirst = event.target.files[0];
        const fileSize = bytesToMB(uploadedFileFirst.size);
        const secondOption = document.getElementById("broadcast-image-2");
        const removeIcon = document.getElementById("first-image-remove-icon");
    
        if (fileSize <= 5) {
            if (uploadedFileFirst.type === strings.imageJpeg || uploadedFileFirst.type === strings.imageJpg) {
                setImageArray(prevImageArray => {
                    const newArray = [...prevImageArray];
                    newArray[0] = uploadedFileFirst;
                    return newArray;
                });
                removeIcon.className="remove-icon-broadcast-img"
                secondOption.className="me-2 broadcast-image-id"
                const firstImage = document.getElementById("first-broadcast-image");
                var tempElement = document.createElement("img");
                tempElement.id="first-uploaded-broadcast";
                const imageURL = URL.createObjectURL(uploadedFileFirst);
                tempElement.src = imageURL;
                tempElement.className= "uploaded-broadcast-image-name"
                firstImage.innerHTML = ''; 
                firstImage.appendChild(tempElement);
            } else {
                toast.error(strings.fileFormat, { toastId: strings.errorCode });
            }
        } else {
            toast.error(strings.fileSize, { toastId: strings.errorCode });
        }
    }

    function secondFileUpload(event) {
        const uploadedFileFirst = event.target.files[0];
        const fileSize = bytesToMB(uploadedFileFirst.size);
        const thirdOption = document.getElementById("broadcast-image-3");
        const removeIcon = document.getElementById("second-image-remove-icon");
    
        if (fileSize <= 5) {
            if (uploadedFileFirst.type === "image/jpeg" || uploadedFileFirst.type === "image/jpg") {
                setImageArray(prevImageArray => {
                    const newArray = [...prevImageArray];
                    newArray[1] = uploadedFileFirst;
                    return newArray;
                });
                removeIcon.className="remove-icon-broadcast-img"
                thirdOption.className="me-2 broadcast-image-id"
                const firstImage = document.getElementById("second-broadcast-image");
                var tempElement = document.createElement("img");
                tempElement.id="second-uploaded-broadcast"
                const imageURL = URL.createObjectURL(uploadedFileFirst);
                tempElement.src = imageURL;
                tempElement.className= "uploaded-broadcast-image-name"
                firstImage.innerHTML = ''; 
                firstImage.appendChild(tempElement);
            } else {
                toast.error(strings.fileFormat, { toastId: strings.errorCode });
            }
        } else {
            toast.error(strings.fileSize, { toastId: strings.errorCode });
        }
    }

    function thirdFileUpload(event) {
        const uploadedFileFirst = event.target.files[0];
        const fileSize = bytesToMB(uploadedFileFirst.size);
        const removeIcon = document.getElementById("third-image-remove-icon");
    
        if (fileSize <= 5) {
            if (uploadedFileFirst.type === "image/jpeg" || uploadedFileFirst.type === "image/jpg") {
                const firstImage = document.getElementById("third-broadcast-image");
                setImageArray(prevImageArray => {
                    const newArray = [...prevImageArray];
                    newArray[2] = uploadedFileFirst;
                    return newArray;
                });
                removeIcon.className="remove-icon-broadcast-img";
                var tempElement = document.createElement("img");
                const imageURL = URL.createObjectURL(uploadedFileFirst);
                tempElement.src = imageURL;
                tempElement.className= "uploaded-broadcast-image-name"
                tempElement.id="third-uploaded-broadcast"
                firstImage.innerHTML = ''; 
                firstImage.appendChild(tempElement);
            } else {
                toast.error(strings.fileFormat, { toastId: strings.errorCode });
            }
        } else {
            toast.error(strings.fileSize, { toastId: strings.errorCode });
        }
    }

    let filteredArray = imageArray.filter(item => item !== null);
    
    useEffect(()=>{
        setFileNumber(filteredArray.length);
    },[filteredArray])

    return (
        <div className="main-container-of-broadcast">
        
        {fetchingEmployeeName ? <div className="loader-for-broadcast"><SpinnerButton/></div> : <div className="sub-container-of-create-broadcast">
        <div className="back-link-broadcast" >
           <div className="notify-all-divider">
           <div className="back-broadcast-arrow" onClick={(()=>{nav(constants.navigationLink.broadcast)})}><img src={BackArrow} alt="back-arrow" className="create-broadcast-back-arrow"/></div>
            <div className="back-broadcast-name" onClick={(()=>{nav(constants.navigationLink.broadcast)})}>{strings.broadcastingLabel}</div>
           </div>
           <div>
           <div className="notify-all-icon">{strings.notifyAll}<input type="checkbox" checked={broadCastReachability} className="notify-all-broadcast-button" onChange={((e)=>{setBroadcastReachability(e.target.checked)})}/></div>
           </div>
           </div>
           <div className="create-broadcast-details">
           <div className="title-of-broadcast  broadcast-fields">
           <label htmlFor="">{strings.notificationTitle}</label>
           <input type="text" className="input-of-create-broadcast" placeholder="Title" onChange={((event)=>{setTitleOfNotification(event.target.value)})}/>
           </div>
           <div className="type-of-broadcast broadcast-fields">
           <label htmlFor="">{strings.notificationType}</label>
           <Select 
           options={constants.broadcastType}
            styles={appStyles.companyProfileDropdown}
            onChange={((value)=>{ setTypeBroadcast(value)})}
            className="selection-broadcast-type"
            placeholder="Select type"
           />
           </div>
           <div className="content-of-broadcast broadcast-fields">
           <label htmlFor="">{strings.contentNotification}</label>
           <textarea type="text" className="input-of-create-broadcast" placeholder="Enter content here" onChange={((event)=>{setContentOfNotification(event.target.value)})}/>
           </div>
           {!broadCastReachability ?  <div className="selected-employee-broadcast">
            <label htmlFor="">{strings.selectEmployee}</label>
           <Select 
           options={activeEmployees}
            styles={appStyles.employeeSelectionBroadcast}
            className="selection-broadcast-type"
            placeholder="Select reachability"
            onChange={((value)=>{setSelectedEmployee(value)})}
            isMulti
           />
            </div> : null}
            <div className="upload-image-in-broadcast mt-3">
            <div className="upload-label-broadcast"> {strings.uploadImage} ({fileNumber}/3)</div>
            <div className="upload-image-labels" id="upload-image-labels">   
                <div className="me-2 broadcast-image-id" id="broadcast-image-1">
                <div className="remove-icon-broadcast-img d-none" id="first-image-remove-icon" onClick={(()=>{
                    removeFileFirst();
                })}>
                    <img src={RemoveIcon} alt="remove-icon" />
                </div>
                <label htmlFor="upload-image" className="upload-image-label" id="up-1">
                <div id="first-broadcast-image" className="broadcast-image-change-section">
                        <img src={AddImage} alt="add-img" className="add-img-icon-broadcast" id="first-uploaded-broadcast"/>
                        <div className="limit-broadcast-image">{strings.limitLabel}</div>
                </div>
                    </label>
                    <input type="file" accept="image/jpeg , image/jpg" className="d-none" id="upload-image" onChange={((event)=>{firstFileUpload(event)})}/>
                </div>
                <div className="me-2 d-none" id="broadcast-image-2">
                <div className="remove-icon-broadcast-img d-none" id="second-image-remove-icon" onClick={(()=>{
                    removeFileSecond();
                })}>
                    <img src={RemoveIcon} alt="remove-icon" />
                </div>
                <label htmlFor="upload-image-second" className="upload-image-label" id="up-2">
                <div id="second-broadcast-image" className="broadcast-image-change-section">
                        <img src={AddImage} alt="add-img" className="add-img-icon-broadcast" id="second-uploaded-broadcast"/>
                        <div className="limit-broadcast-image">{strings.limitLabel}</div>
                </div>
                    </label>
                    <input type="file" accept="image/jpeg , image/jpg" className="d-none" id="upload-image-second" onChange={((event)=>{secondFileUpload(event)})}/>
                </div>
                <div className="me-2 d-none" id="broadcast-image-3">
                <div className="remove-icon-broadcast-img d-none" id="third-image-remove-icon" onClick={(()=>{
                    removeFileThird();
                })}>
                    <img src={RemoveIcon} alt="remove-icon" />
                </div>
                <label htmlFor="upload-image-third" className="upload-image-label" id="up-3">
                <div id="third-broadcast-image" className="broadcast-image-change-section">
                        <img src={AddImage} alt="add-img" className="add-img-icon-broadcast" id="third-uploaded-broadcast"/>
                        <div className="limit-broadcast-image">{strings.limitLabel}</div>
                </div>
                    </label>
                    <input type="file" accept="image/jpeg , image/jpg" className="d-none" id="upload-image-third" onChange={((event)=>{thirdFileUpload(event)})}/>
                </div>    
            </div>
            </div>    
           </div>
           <div className="buttons-of-broadcast mt-2">
                <button className="broadcast-cancel-button" disabled={creatingBroadcast} onClick={(()=>{nav(constants.navigationLink.broadcast)})}>{strings.cancel}</button>
                <button className="broadcast-button-second" disabled={
                    titleOfBroadcast.trim()==="" || contentOfNotification.trim()==="" || typeBroadcast===null || creatingBroadcast
                } onClick={(()=>{createBroadCast()})}>{creatingBroadcast ? <SpinnerButtonMedium/> :  strings.broadcastIt}</button>
            </div>
        </div>}
    </div>
    )
}